import dateFormat from 'dateformat';
import { useFormik } from 'formik';
import React, { useMemo, useState } from 'react';
import TableCustom from '../../../../components/MyCustom/TableCustom';
import FilterReports from '../../../../components/MyCustom/filterReports';
import Breadcrumb from '../../../../components/bootstrap/Breadcrumb';
import Card, { CardBody, CardHeader, CardLabel, CardTitle } from '../../../../components/bootstrap/Card';
import Spinner from '../../../../components/bootstrap/Spinner';
import FormGroup from '../../../../components/bootstrap/forms/FormGroup';
import Label from '../../../../components/bootstrap/forms/Label';
import Select from '../../../../components/bootstrap/forms/Select';
import Money from '../../../../helpers/utils/money/money';
import useSalesConsumptions from '../../../../hooks/reports/useSalesConsumptions';
import Page from '../../../../layout/Page/Page';
import PageWrapper from '../../../../layout/PageWrapper/PageWrapper';
import SubHeader, { SubHeaderLeft, SubHeaderRight } from '../../../../layout/SubHeader/SubHeader';
import { demoPages } from '../../../../menu';

const TYPES = {
  ALL: 'Todos',
  PRODUCT: 'Produto',
  COMPLEMENT: 'Complemento',
};

const TYPES_PT_BR = {
  [TYPES.ALL]: 'Todos',
  [TYPES.PRODUCT]: 'Produtos',
  [TYPES.COMPLEMENT]: 'Complementos',
};

const formatDate = value => {
  const date = typeof value?.toDate === 'function' ? value.toDate() : new Date(value);
  return Number.isNaN(date.getTime()) ? '' : dateFormat(date, 'dd/mm/yyyy HH:MM');
};

const ConsumptionsHistory = () => {
  const [filterMenu, setFilterMenu] = useState(false);
  const [dataFilter, setDataFilter] = useState({});
  const { allConsumptions, loading } = useSalesConsumptions(filterMenu, dataFilter);

  const columns = useMemo(() => ([
    {
      label: 'Lançamento',
      field: 'created_at',
      format: row => formatDate(row.created_at),
      isDate: true,
    },
    {
      label: 'Operador',
      field: 'operator',
    },
    {
      label: 'Produto',
      field: 'name',
    },
    {
      label: 'Tipo',
      field: 'type',
    },
    {
      label: 'Qtd',
      field: 'qtd',
    },
    {
      label: 'Preço',
      field: 'price',
      format: row => Money.centsToMaskMoney(row.price),
      isCurrency: true,
    },
  ]), []);

  const formik = useFormik({
    initialValues: {
      typeProductSelected: TYPES.ALL,
    },
    onSubmit: () => {},
  });

  const optionsProducts = useMemo(() => Object.values(TYPES).map(item => ({
    value: item,
    text: TYPES_PT_BR[item],
  })), []);

  const consumptions = useMemo(() => {
    const typeProductSelected = formik.values.typeProductSelected;

    return allConsumptions.filter((consumption) => {
      const matchProduct = typeProductSelected === TYPES.ALL || consumption.type === typeProductSelected;
      return matchProduct;
    });
  }, [formik.values.typeProductSelected, allConsumptions]);

  return (
    <PageWrapper title={demoPages.reports.subMenu.consumptionsHistory.text}>
      <SubHeader>
        <SubHeaderLeft>
          <Breadcrumb
            list={[
              { title: 'Relatórios', to: '/reports' },
              {
                title: 'Histórico de Consumos',
                to: '/reports/consumptionsHistory',
              },
            ]}
          />
        </SubHeaderLeft>
        <SubHeaderRight>
          <FilterReports
            filterMenu={filterMenu}
            setFilterMenu={setFilterMenu}
            setDataFilter={setDataFilter}
          />
        </SubHeaderRight>
      </SubHeader>
      <Page container='fluid' className='h-100'>
        {loading ? (
          <div className='d-flex flex-column justify-content-center align-items-center h-100'>
            <Spinner size={50} />
          </div>
        ) : (
          <Card>
            <CardHeader borderSize={1}>
              <CardLabel icon='Inventory2' iconColor='dark'>
                <CardTitle>HISTÓRICO DE CONSUMOS</CardTitle>
              </CardLabel>
            </CardHeader>

            <CardBody className='table-responsive p-5'>
              <div className='d-flex gap-4'>
                <FormGroup>
                  <Label htmlFor='typeProductSelected'>Tipo de Produto</Label>
                  <Select
                    id='typeProductSelected'
                    placeholder='Selecione o tipo do produto'
                    list={optionsProducts}
                    onChange={formik.handleChange}
                    value={formik.values.typeProductSelected}
                  />
                </FormGroup>
              </div>

              <TableCustom
                titlePdf='Historico de Consumo'
                fontSize={8}
                columns={columns}
                rows={consumptions}
                keyExtractor={row => row.id}
                fileName='Historico-Consumo'
              />
            </CardBody>
          </Card>
        )}
      </Page>
    </PageWrapper>
  );
};

export default ConsumptionsHistory;
